import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../../api/apiFactory";
import { showNotification } from "../notificationSlice";
const jReportsApi = factory.get("jReport");
const initialState = {
  searchBody: {},
  loading: false,
  jRevenue: {
    loading: false,
    data: null,
    total: 0,
    total_amount: 0,
    total_debt: 0,
  },
  jCash: {
    loading: false,
    data: [],
    total: 0,
    jCash: 0,
  },
  jRep: {
    loading: false,
    data: [],
    total: 0,
  },
  jRepStatistics: {
    loading: false,
    data: [],
    total: 0,
  },
  addedJItems: {
    loading: false,
    data: [],
    total: 0,
    total_amount: 0,
  },
  soldJItems: {
    loading: false,
    data: [],
    total: 0,
    total_amount: 0,
  },
  jItemsSummaryTotal: {
    loading: false,
    data: [],
    total: 0,
    total_amount: 0,
    total_debt: 0,
  },
  jPosDebt: {
    loading: false,
    data: [],
    total: 0,
    total_amount: 0,
  },
  jPosDebtMonthly: {
    loading: false,
  },
  reportTypes: [
    {
      type: "الكاش",
      name: "cash",
      isSelected: false,
      permission: "j_cash_report",
    },
    {
      type: "تفاصيل المندوبين",
      name: "rep",
      isSelected: false,
      permission: "j_rep_report",
    },
    {
      type: "مبيعات المندوبين",
      name: "rep_statistics",
      isSelected: false,
      permission: "j_rep_statistics_report",
    },
    {
      type: "حركات البيع",
      name: "added_j_item",
      isSelected: false,
      permission: "j_item_summary_report",
    },
    {
      type: "حركات الشراء",
      name: "sold_j_item",
      isSelected: false,
      permission: "j_item_invoice_summary_report",
      roles: ["super_admin"],
    },
    {
      type: "مجموع حركات المادة",
      name: "j_item_summary_total",
      isSelected: false,
      permission: "j_item_summary_total_report",
    },
    {
      type: "ديون النقاط",
      name: "j_pos_debt",
      isSelected: false,
      permission: "j_pos_debt_report",
    },
    {
      type: "الارباح",
      name: "j_revenue",
      isSelected: false,
      permission: "j_revenue_report",
      roles: ["super_admin"],
    },
    {
      type: "تقرير مديونية نقاط البيع الشهرية",
      name: "j_pos_debt_monthly",
      isSelected: false,
      permission: "j_pos_debt_monthly_report",
    },
  ],
};

export const jReportsSlice = createSlice({
  name: "jReports",
  initialState,
  reducers: {
    setJRevenueTable: (state, { payload }) => {
      state.jRevenue.data = payload.data.data;
      state.jRevenue.total = payload.data.total;
      state.jRevenue.total_amount = payload.data.total_amount;
      state.jRevenue.total_debt = payload.data.total_debt;
    },
    setJCashTable: (state, { payload }) => {
      state.jCash.data = payload.data.data;
      state.jCash.total = payload.data.total;
      state.jCash.jCash = payload.data.total_amount;
    },
    setJRepTable: (state, { payload }) => {
      state.jRep.data = payload.data.data;
      state.jRep.total = payload.data.total;
    },
    setJRepStatisticsTable: (state, { payload }) => {
      state.jRepStatistics.data = payload.data.data;
      state.jRepStatistics.total = payload.data.total;
    },
    setAddedJItemsTable: (state, { payload }) => {
      state.addedJItems.data = payload.data.data;
      state.addedJItems.total = payload.data.total;
      state.addedJItems.total_amount = payload.data.total_amount;
    },
    setSoldJItemsTable: (state, { payload }) => {
      state.soldJItems.data = payload.data.data;
      state.soldJItems.total = payload.data.total;
      state.soldJItems.total_amount = payload.data.total_amount;
    },
    setJItemsSummaryTotalTable: (state, { payload }) => {
      state.jItemsSummaryTotal.data = payload.data.data;
      state.jItemsSummaryTotal.total = payload.data.total;
      state.jItemsSummaryTotal.total_amount = payload.data.total_amount;
      state.jItemsSummaryTotal.total_debt = payload.data.total_debt;
    },
    setJPosDebtTable: (state, { payload }) => {
      state.jPosDebt.data = payload.data.data;
      state.jPosDebt.total = payload.data.total;
      state.jPosDebt.total_amount = payload.data.total_amount;
    },
    setJPosDebtMonthlyLoading: (state, { payload }) => {
      state.jPosDebtMonthly.loading = payload;
    },
    setLoading: (state, action) => {
      state.loading = !state.loading;
    },
    setSearchBody: (state, { payload }) => {
      state.searchBody = payload;
    },
    setSelectedReport: (state, { payload }) => {
      state.reportTypes = state.reportTypes.map((type) =>
        type.name === payload
          ? { ...type, isSelected: true }
          : { ...type, isSelected: false }
      );
    },
  },
});

export const {
  setLoading,
  setSearchBody,
  setJCashTable,
  setSelectedReport,
  setJRepStatisticsTable,
  setJRepTable,
  setSoldJItemsTable,
  setAddedJItemsTable,
  setJItemsSummaryTotalTable,
  setJPosDebtTable,
  setJRevenueTable,
  setJPosDebtMonthlyLoading,
} = jReportsSlice.actions;

export default jReportsSlice.reducer;

//axios
const jCash = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("jReports"));
    const res = await jReportsApi.jCash(data);
    dispatch(setJCashTable(res));
    dispatch(setLoading("jReports"));
  } catch (err) {
    dispatch(setLoading("jReports"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const jRep = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("jReports"));
    const res = await jReportsApi.jRep(data);
    dispatch(setJRepTable(res));
    dispatch(setLoading("jReports"));
  } catch (err) {
    dispatch(setLoading("jReports"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

const addedJItems = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("jReports"));
    const res = await jReportsApi.jItemAddedSummaryReport(data);
    dispatch(setAddedJItemsTable(res));
    dispatch(setLoading("jReports"));
  } catch (err) {
    dispatch(setLoading("jReports"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const soldJItems = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("jReports"));
    const res = await jReportsApi.jItemSoldSummeryReport(data);
    dispatch(setSoldJItemsTable(res));
    dispatch(setLoading("jReports"));
  } catch (err) {
    dispatch(setLoading("jReports"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const jItemsSummaryTotal = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("jReports"));
    const res = await jReportsApi.jItemSummeryTotalReport(data);
    dispatch(setJItemsSummaryTotalTable(res));
    dispatch(setLoading("jReports"));
  } catch (err) {
    dispatch(setLoading("jReports"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const jRepStatistics = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("jReports"));
    const res = await jReportsApi.jRepStatistics(data);
    dispatch(setJRepStatisticsTable(res));
    dispatch(setLoading("jReports"));
  } catch (err) {
    dispatch(setLoading("jReports"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const jPosDebt = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("jReports"));
    const res = await jReportsApi.jPosDebt(data);
    dispatch(setJPosDebtTable(res));
    dispatch(setLoading("jReports"));
  } catch (err) {
    dispatch(setLoading("jReports"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const jRevenue = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("jReports"));
    const res = await jReportsApi.jRevenue(data);
    dispatch(setJRevenueTable(res));
    dispatch(setLoading("jReports"));
  } catch (err) {
    dispatch(setLoading("jReports"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const jPosDebtMonthly = (data) => async (dispatch) => {
  try {
    dispatch(setJPosDebtMonthlyLoading(true));
    const res = await jReportsApi.jPosDebtMonthly({
      ...data,
      is_excel: 1,
    });
    let url = window.URL.createObjectURL(res.data);
    let a = document.createElement("a");
    a.href = url;
    a.download = `pos-debt-monthly-report-${data.start_date}-${data.end_date}.xlsx`;
    a.click();
    dispatch(setJPosDebtMonthlyLoading(false));
    dispatch(
      showNotification({
        message: "تم تصدير التقرير بنجاح",
        type: "success",
      })
    );
  } catch (err) {
    dispatch(setJPosDebtMonthlyLoading(false));
    dispatch(
      showNotification({
        message:
          err.response?.data?.errors?.[0] || "حدث خطأ أثناء تصدير التقرير",
        type: "error",
      })
    );
    throw new Error(err);
  }
};
export const JReports = {
  jCash,
  jRep,
  jRepStatistics,
  soldJItems,
  addedJItems,
  jItemsSummaryTotal,
  jPosDebt,
  jRevenue,
  jPosDebtMonthly,
};
